import React from 'react';
import { Tooltip } from 'antd';
import IconComponent from '../IconComponent/IconComponent';
import { warrantyIds, tooltipTitles } from '../../../../config';

const InactiveComponent = ({ warrantyId, actionProps }) => {
  if (warrantyId === warrantyIds.notWarranty) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitles[warrantyId].inactive || ''}>
      <IconComponent
        {...actionProps}
        warrantyId={warrantyId}
      />
    </Tooltip>
  );
};

export default InactiveComponent;
